jQuery(function ($) {
  const breakpoint = window.matchMedia('(max-width: 1162px)');
  const speed = 40;
  const sliders = [];

  $('[data-rotating-text]').each(function () {
    const $slider = $(this);
    let flickity = null;
    let frame = null;
    let lastTime = null;

    function animate(time) {
      if (!flickity) return;

      const delta = lastTime === null
        ? 0
        : Math.min(time - lastTime, 50);

      lastTime = time;

      if (flickity.slideableWidth > 0) {
        flickity.x -= (speed * delta) / 1000;
        flickity.x %= flickity.slideableWidth;
        flickity.positionSlider();
      }

      frame = requestAnimationFrame(animate);
    }

    function stop() {
      cancelAnimationFrame(frame);
      frame = null;
      lastTime = null;
    }

    function update() {
      if (breakpoint.matches) {
        if (flickity) return;

        if ($slider.data('flickity')) {
          $slider.flickity('destroy');
        }

        $slider.flickity({
          cellAlign: 'left',
          wrapAround: true,
          autoPlay: false,
          cellSelector: '.rotating_text-column',
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
          accessibility: false,
          percentPosition: false,

        });

        flickity = $slider.data('flickity');
        frame = requestAnimationFrame(animate);
      } else if (flickity) {
        stop();
        $slider.flickity('destroy');
        flickity = null;
      }
    }

    sliders.push({
      update: update,
      resume: function () {
        stop();

        if (flickity && !document.hidden) {
          frame = requestAnimationFrame(animate);
        }
      }
    });

    update();
  });

  breakpoint.addEventListener('change', function () {
    sliders.forEach(function (slider) {
      slider.update();
    });
  });

  document.addEventListener('visibilitychange', function () {
    sliders.forEach(function (slider) {
      slider.resume();
    });
  });
});